///<reference path="./resource-with-categories.ts"/>

module Meevo.Components.Controls.SmartMover {
    export class ReportResourcesWithCategories extends ResourcesWithCategories {
        reconnectLeafCollectionModel(model) {
             this.leafCollection.connectedModel = this.resources.connectedModel || model[this.properties[1]];
        }
    }
}
